import React, { useState, useEffect } from 'react';
import { useActivityContext } from '../index';

const CompetencyProfilePage1 = () => {
  const { activity } = useActivityContext();
  const [profileData, setProfileData] = useState({ awareness: {} });

  const initializeAbility = () => ({
    grade_9: { B: false, P: false, A: false },
    grade_10: { B: false, P: false, A: false },
    grade_11: { B: false, P: false, A: false },
    grade_12: { B: false, P: false, A: false }
  });

  useEffect(() => {
    if (activity?.competency_profile?.page_1) {
      setProfileData({ awareness: activity.competency_profile.page_1.awareness || {} });
    } else {
      const awarenessAbilities = [
        'proficiency_in_language', 'oral_communication', 'written_communication',
        'health_nutrition_literacy', 'physical_education', 'digital_literacy',
        'knowledge_of_india', 'environmental_literacy', 'knowledge_critical_issues'
      ];
      const awareness = {};
      awarenessAbilities.forEach(ability => { awareness[ability] = initializeAbility(); });
      setProfileData({ awareness });
    }
  }, [activity]);

  const awarenessAbilities = [
    { key: 'proficiency_in_language', label: 'Proficiency in language\\nR1, R2, R3' },
    { key: 'oral_communication', label: 'Oral communication' },
    { key: 'written_communication', label: 'Written communication' },
    { key: 'health_nutrition_literacy', label: 'Health and nutrition\\nliteracy' },
    { key: 'physical_education', label: 'Physical education,\\nfitness, wellness,\\nand sports' },
    { key: 'digital_literacy', label: 'Digital literacy' },
    { key: 'knowledge_of_india', label: 'Knowledge of India' },
    { key: 'environmental_literacy', label: 'Environmental\\nliteracy (including\\nawareness of water\\nand resource,\\nconservation,\\nsanitation and\\nhygiene, etc.)' },
    { key: 'knowledge_critical_issues', label: 'Knowledge of\\ncritical issues\\n(including current\\naffairs and facing\\nlocal communities,\\nStates, the country,\\nand the world, etc.)' }
  ];

  const grades = [
    { key: 'grade_9', label: 'GRADE - 9', bgColor: '#A8D08D' },
    { key: 'grade_10', label: 'GRADE - 10', bgColor: '#9DC3E6' },
    { key: 'grade_11', label: 'GRADE - 11', bgColor: '#FFD966' },
    { key: 'grade_12', label: 'GRADE - 12', bgColor: '#F4B183' }
  ];

  const renderAbilityRow = (ability, index) => {
    const abilityData = profileData.awareness?.[ability.key] || initializeAbility();
    const rowBg = index % 2 === 0 ? '#F²F2F2' : '#FFFFFF';

    return (
      <tr key={ability.key} style={{ backgroundColor: rowBg }}>
        <td style={{
          padding: '12px 15px',
          fontSize: '15px',
          color: 'white',
          backgroundColor: '#4472C4',
          border: '1px solid #2C3E50',
          whiteSpace: 'pre-line',
          lineHeight: '1.4',
          verticalAlign: 'top'
        }}>
          {String.fromCharCode(97 + index)}) {ability.label}
        </td>
        {grades.map(grade => (
          <React.Fragment key={grade.key}>
            {['B', 'P', 'A'].map(level => (
              <td key={level} style={{
                padding: '8px',
                textAlign: 'center',
                backgroundColor: grade.bgColor,
                border: '1px solid #999',
                width: '50px'
              }}>
                {abilityData[grade.key]?.[level] && (
                  <div style={{
                    width: '20px',
                    height: '20px',
                    margin: '0 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#333'
                  }}>
                    ✓
                  </div>
                )}
              </td>
            ))}
          </React.Fragment>
        ))}
      </tr>
    );
  };

  return (
    <div style={{
      maxWidth: '1400px',
      margin: '0 auto',
      padding: '40px',
      backgroundColor: 'white',
      fontFamily: "'Poppins', Arial, sans-serif",
      position: 'relative',
      boxSizing: 'border-box'
    }}>
      {/* Top-right orange corner */}
      

      {/* Title */}
      <div style={{
        color: '#2C5F7E',
        fontSize: '26px',
        fontWeight: 'bold',
        textAlign: 'center',
        marginBottom: '30px'
      }}>
        Student's Competency Profile
      </div>

      {/* Table */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        border: '2px solid #2C3E50',
        marginBottom: '40px'
      }}>
        {/* Header Row */}
        <thead>
          <tr>
            <th rowSpan={2} style={{
              padding: '15px',
              textAlign: 'center',
              fontSize: '16px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#1E3A5F',
              border: '1px solid #2C3E50',
              width: '250px'
            }}>
              ABILITIES
            </th>
            <th colSpan={12} style={{
              padding: '12px',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#2C4A6F',
              border: '1px solid #2C3E50'
            }}>
              Performance Level Descriptors
            </th>
          </tr>
          <tr>
            {grades.map(grade => (
              <th key={grade.key} colSpan={3} style={{
                padding: '10px',
                textAlign: 'center',
                fontSize: '15px',
                fontWeight: 'bold',
                color: '#333',
                backgroundColor: grade.bgColor,
                border: '1px solid #999'
              }}>
                {grade.label}
              </th>
            ))}
          </tr>
          <tr style={{ backgroundColor: '#E7E6E6' }}>
            <th style={{
              padding: '10px',
              textAlign: 'center',
              fontSize: '14px',
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: '#4472C4',
              border: '1px solid #2C3E50'
            }}>
              1. AWARENESS
            </th>
            {grades.map(grade => (
              <React.Fragment key={grade.key}>
                {['B', 'P', 'A'].map(level => (
                  <th key={level} style={{
                    padding: '8px',
                    textAlign: 'center',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    color: '#333',
                    backgroundColor: '#E7E6E6',
                    border: '1px solid #999'
                  }}>
                    {level}
                  </th>
                ))}
              </React.Fragment>
            ))}
          </tr>
        </thead>

        {/* Body - Awareness Abilities */}
        <tbody>
          {awarenessAbilities.map((ability, index) => renderAbilityRow(ability, index))}
        </tbody>
      </table>

      {!activity?.competency_profile?.page_1 && (
        <div style={{
          backgroundColor: '#FFF9E6',
          border: '2px dashed #F4CD8A',
          borderRadius: '8px',
          padding: '20px',
          textAlign: 'center',
          color: '#666',
          fontSize: '14px',
          marginTop: '20px'
        }}>
          <p>Your teacher has not yet completed your competency profile assessment.</p>
        </div>
      )}

      {/* Page Number */}
      <div style={{
        textAlign: 'center',
        fontSize: '14px',
        color: '#666',
        fontWeight: 'bold',
        marginTop: '30px'
      }}>
        1
      </div>

      {/* Bottom-left orange corner */}
      

      {/* Bottom-right decorative corner */}
      
    </div>
  );
};

export default CompetencyProfilePage1;
